import metaCapi from './settings/metaCapi.routes';

export { settingsPermissions } from './permissions';

export const settingsRoutes = [...metaCapi.routes];

export const settingsNavItems = ({ accountScopedRoute, t }) => [
  {
    name: 'Settings Meta CAPI',
    label: t('SIDEBAR.META_CAPI'),
    icon: 'i-lucide-target',
    to: accountScopedRoute('astrachat_meta_capi'),
  },
];
